(function () {
  'use strict';

  /*
   * 自动赠品设置
   * 买下列任意商品，自动赠送一件 Remote Control Page Turner。
   */

  const FREE_GIFT_CONFIG = {
    /*
     * 你提供的购买商品编号。
     * 代码会同时检查 Product ID 和 Variant ID，
     * 因此即使其中混合了两种编号，也可以识别。
     */
    qualifyingIds: [
      9937084023060,
      51157644050708,
      51157644116244,
      51189932359956,
      51157644083476,
      51157644149012,
      51189932392724,
      51179404460308,
      51189932458260,
      9633779515668,
      49658769244436,
      49655046177044,
      49655046209812
    ],

    // Remote Control Page Turner 的正确 Variant ID
    giftVariantId: 51522567831828,

    // 每个订单赠送数量
    giftQuantity: 1
  };

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const CART_URL = root + 'cart.js';
  const ADD_URL = root + 'cart/add.js';
  const CHANGE_URL = root + 'cart/change.js';

  const qualifyingIds = new Set(
    FREE_GIFT_CONFIG.qualifyingIds.map(function (id) {
      return String(id);
    })
  );

  let syncRunning = false;
  let syncTimer = null;

  function isGift(item) {
    return (
      String(item.variant_id) ===
        String(FREE_GIFT_CONFIG.giftVariantId) &&
      item.properties &&
      String(item.properties._free_gift) === 'true'
    );
  }

  function isQualifyingProduct(item) {
    if (isGift(item)) {
      return false;
    }

    return (
      qualifyingIds.has(String(item.product_id)) ||
      qualifyingIds.has(String(item.variant_id))
    );
  }

  async function readCart() {
    const response = await fetch(CART_URL, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read cart.');
    }

    return response.json();
  }

  async function addFreeGift() {
    const response = await fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(FREE_GIFT_CONFIG.giftVariantId),
            quantity: Number(FREE_GIFT_CONFIG.giftQuantity),
            properties: {
              _free_gift: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      let errorMessage = 'Unable to add free gift.';

      try {
        const errorData = await response.json();
        errorMessage =
          errorData.description ||
          errorData.message ||
          errorMessage;
      } catch (error) {
        // 使用默认错误信息
      }

      throw new Error(errorMessage);
    }
  }

  async function changeGiftQuantity(lineKey, quantity) {
    const response = await fetch(CHANGE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update free gift.');
    }
  }

  async function syncFreeGift() {
    if (syncRunning) {
      return;
    }

    syncRunning = true;

    try {
      const cart = await readCart();

      const hasQualifyingProduct =
        cart.items.some(isQualifyingProduct);

      const giftLines =
        cart.items.filter(isGift);

      const firstGift =
        giftLines.length > 0 ? giftLines[0] : null;

      let cartWasChanged = false;

      /*
       * 有符合活动条件的商品，但没有赠品：
       * 自动添加赠品。
       */
      if (hasQualifyingProduct && !firstGift) {
        await addFreeGift();
        cartWasChanged = true;
      }

      /*
       * 符合条件的商品全部被删除后：
       * 自动删除赠品。
       */
      if (!hasQualifyingProduct && giftLines.length > 0) {
        for (const giftLine of giftLines) {
          await changeGiftQuantity(giftLine.key, 0);
        }

        cartWasChanged = true;
      }

      /*
       * 防止顾客把赠品数量改成两件或更多。
       */
      if (
        hasQualifyingProduct &&
        firstGift &&
        Number(firstGift.quantity) !==
          Number(FREE_GIFT_CONFIG.giftQuantity)
      ) {
        await changeGiftQuantity(
          firstGift.key,
          FREE_GIFT_CONFIG.giftQuantity
        );

        cartWasChanged = true;
      }

      /*
       * 如果重复产生多条赠品，只保留第一条。
       */
      if (hasQualifyingProduct && giftLines.length > 1) {
        for (
          let index = 1;
          index < giftLines.length;
          index++
        ) {
          await changeGiftQuantity(
            giftLines[index].key,
            0
          );
        }

        cartWasChanged = true;
      }

      if (cartWasChanged) {
        window.location.reload();
      }
    } catch (error) {
      console.error(
        'Levaplus free gift error:',
        error
      );
    } finally {
      syncRunning = false;
    }
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(function () {
      syncFreeGift();
    }, delay || 500);
  }

  /*
   * 监听使用 fetch 发出的购物车请求。
   */
  const originalFetch = window.fetch;

  window.fetch = async function () {
    const args = arguments;
    const response =
      await originalFetch.apply(this, args);

    try {
      const request = args[0];

      const requestUrl =
        typeof request === 'string'
          ? request
          : request && request.url
            ? request.url
            : '';

      const isCartChange =
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('/cart/change') ||
        requestUrl.includes('/cart/update') ||
        requestUrl.includes('/cart/clear');

      if (isCartChange && !syncRunning) {
        scheduleSync(500);
      }
    } catch (error) {
      console.error(
        'Free gift fetch listener error:',
        error
      );
    }

    return response;
  };

  /*
   * 兼容使用 XMLHttpRequest 的购物车主题。
   */
  const originalXhrOpen =
    XMLHttpRequest.prototype.open;

  const originalXhrSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url
  ) {
    this._freeGiftRequestUrl = String(url || '');

    return originalXhrOpen.apply(
      this,
      arguments
    );
  };

  XMLHttpRequest.prototype.send = function () {
    const xhr = this;

    xhr.addEventListener(
      'loadend',
      function () {
        const requestUrl =
          xhr._freeGiftRequestUrl || '';

        const isCartChange =
          requestUrl.includes('/cart/add') ||
          requestUrl.includes('/cart/change') ||
          requestUrl.includes('/cart/update') ||
          requestUrl.includes('/cart/clear');

        if (isCartChange && !syncRunning) {
          scheduleSync(500);
        }
      }
    );

    return originalXhrSend.apply(
      this,
      arguments
    );
  };

  /*
   * 页面打开、刷新或返回时检查购物车。
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleSync(250);
      }
    );
  } else {
    scheduleSync(250);
  }

  window.addEventListener(
    'pageshow',
    function () {
      scheduleSync(300);
    }
  );
})();